import type { MainWeapon, SideWeapon, UpgradeId, Pilot } from "./types";
export { SIDE_WEAPONS, starsFor } from "./content-v1";
import { SIDE_WEAPONS } from "./content-v1";
export const MAIN_WEAPONS: {
  id: MainWeapon;
  name: string;
  detail: string;
  color: string;
  interval: number;
  damage: number;
  count: number;
  range: string;
}[] = [
  {
    id: "straight",
    name: "速射机枪",
    detail: "高频点射 · 击杀积攒爆发",
    color: "#4C9AAD",
    interval: 7,
    damage: 12,
    count: 1,
    range: "全屏 / 单体",
  },
  {
    id: "double",
    name: "反弹双枪",
    detail: "双列交叉 · 触边反弹",
    color: "#559B82",
    interval: 14,
    damage: 12,
    count: 2,
    range: "全屏 / 侧翼",
  },
  {
    id: "fan",
    name: "霰弹风暴",
    detail: "近处聚焦 · 扇面清群",
    color: "#C99642",
    interval: 34,
    damage: 16,
    count: 5,
    range: "中程 / 散射",
  },
  {
    id: "laser",
    name: "脉冲激光",
    detail: "持续光束 · 穿透整列",
    color: "#62B3C5",
    interval: 12,
    damage: 24,
    count: 1,
    range: "全屏 / 贯穿",
  },
  {
    id: "flame",
    name: "烈焰喷流",
    detail: "短距高伤 · 持续灼烧",
    color: "#D47F45",
    interval: 8,
    damage: 12,
    count: 2,
    range: "近程 / 灼烧",
  },
  {
    id: "rocket",
    name: "追爆火箭",
    detail: "缓慢追踪 · 范围爆破",
    color: "#CA7371",
    interval: 44,
    damage: 64,
    count: 1,
    range: "远程 / 爆炸",
  },
  {
    id: "rail",
    name: "蓄能轨道炮",
    detail: "蓄力重击 · 贯穿重甲",
    color: "#8B86B9",
    interval: 60,
    damage: 120,
    count: 1,
    range: "全屏 / 蓄力",
  },
  {
    id: "tesla",
    name: "电弧线圈",
    detail: "自动索敌 · 链式传导",
    color: "#999048",
    interval: 27,
    damage: 30,
    count: 1,
    range: "中程 / 连锁",
  },
];
export const weaponInfo = (id: MainWeapon) =>
  MAIN_WEAPONS.find((w) => w.id === id)!;
export interface Upgrade {
  id: UpgradeId;
  name: string;
  detail: string;
  cap: number;
  group: "通用" | "主炮" | "副武器" | "弹道" | "进化";
  requires?: UpgradeId[];
  main?: MainWeapon;
}
const rows: [UpgradeId, string, string, number, Upgrade["group"]][] = [
  ["attack", "浓墨火力", "全部伤害 +25%", 0, "通用"],
  ["rate", "疾速运笔", "射速 +14%（最多5级）", 5, "主炮"],
  ["critical", "灵光一击", "暴击率 +10%，暴击双倍伤害", 5, "通用"],
  ["health", "厚实画纸", "生命上限 +30，立即回复30", 0, "通用"],
  ["repair", "修补涂鸦", "回复50%生命并获得短暂保护", 0, "通用"],
  ["shield", "彩墨护盾", "立即获得40护盾", 0, "通用"],
  ["experience", "创作灵感", "经验 +20%，更多补给", 4, "通用"],
  ["cooldown", "墨水回流", "墨爆冷却 -5秒，最低20秒", 5, "通用"],
  ["grace", "余墨保护", "受击保护 +0.3秒", 4, "通用"],
  ["armor", "纸层装甲", "受到的伤害 -8%", 5, "通用"],
  ["regen", "自愈画纸", "每秒回复0.6生命", 4, "通用"],
  ["lanes", "多重弹道", "额外主炮弹道，总伤害 +35%", 3, "主炮"],
  ["burst", "连续点画", "额外连续弹，总伤害 +30%", 2, "主炮"],
  ["pierce", "穿透笔锋", "额外穿透2个目标", 3, "主炮"],
  ["size", "粗笔弹体", "弹体与光束宽度 +35%", 3, "主炮"],
  ["velocity", "飞速墨点", "弹速/射程 +20%", 3, "主炮"],
  ["push", "冲击笔触", "击退普通敌机", 3, "主炮"],
  ["blast", "扩散墨浪", "爆炸半径 +35%，伤害 +20%", 3, "弹道"],
  ["chain", "导电墨水", "电弧多跳1个敌人", 3, "弹道"],
  ["burn", "余烬画纸", "攻击附加持续灼烧", 3, "弹道"],
  ["frost", "冰蓝笔迹", "命中减速敌机与其发射", 3, "弹道"],
  ["ricochet", "弹跳笔尖", "触边反弹，伤害 +15%", 2, "弹道"],
  ["magnet", "灵感磁铁", "补给吸附范围 +140", 3, "通用"],
  ["overdrive", "连击引擎", "10连击触发6秒火力翻倍", 1, "通用"],
  ["salvage", "拾荒画匣", "补给额外回复12生命", 2, "通用"],
  ["precision", "专注笔锋", "对精英和Boss伤害 +35%", 3, "主炮"],
  ["execution", "终结墨迹", "终结生命低于12%的小兵", 1, "主炮"],
  ["barrier", "护盾回充", "每10秒回复12护盾，容量60", 1, "通用"],
  ["resonance", "共鸣笔触", "每种副武器使主炮伤害 +12%", 2, "通用"],
];
const tuneNames: Record<MainWeapon, [string, string]> = {
  straight: ["重型弹链", "机枪伤害 +25%"],
  double: ["交叉火网", "反弹次数+1，伤害 +25%"],
  fan: ["收束霰弹", "更集中，多2颗弹，总伤害+25%"],
  laser: ["聚焦透镜", "光束更宽，伤害 +25%"],
  flame: ["燃烧风箱", "射程与伤害 +25%"],
  rocket: ["集束弹头", "爆炸更宽，伤害 +25%"],
  rail: ["电容线圈", "蓄力缩短15%，伤害 +25%"],
  tesla: ["超导回路", "多跳1个目标，伤害 +25%"],
};
export const EVOLUTIONS: Record<
  MainWeapon,
  { name: string; requires: UpgradeId[]; detail: string }
> = {
  straight: {
    name: "暴雨加特林",
    requires: ["tune-straight", "rate"],
    detail: "三股弹链与密集追击",
  },
  double: {
    name: "棱镜双星",
    requires: ["tune-double", "ricochet"],
    detail: "交叉反弹四枪",
  },
  fan: {
    name: "飓风霰弹",
    requires: ["tune-fan", "size"],
    detail: "九路霰弹，近距伤害翻倍",
  },
  laser: {
    name: "极光矩阵",
    requires: ["tune-laser", "pierce"],
    detail: "三束贯穿光，附加减速",
  },
  flame: {
    name: "不灭凤凰",
    requires: ["tune-flame", "burn"],
    detail: "广域长焰，击杀爆燃",
  },
  rocket: {
    name: "流星集群",
    requires: ["tune-rocket", "blast"],
    detail: "双发追踪与二次爆破",
  },
  rail: {
    name: "天穹穿刺",
    requires: ["tune-rail", "precision"],
    detail: "超宽轨道束，重击Boss",
  },
  tesla: {
    name: "雷云网络",
    requires: ["tune-tesla", "chain"],
    detail: "超长闪电传导链",
  },
};
export const UPGRADES: Upgrade[] = [
  ...rows.map(([id, name, detail, cap, group]) => ({
    id,
    name,
    detail,
    cap,
    group,
  })),
  ...SIDE_WEAPONS.map((w) => ({
    id: w.id,
    name: w.name,
    detail: w.detail + "；增加火力",
    cap: 5,
    group: "副武器" as const,
  })),
  ...MAIN_WEAPONS.map((w) => ({
    id: `tune-${w.id}` as UpgradeId,
    name: tuneNames[w.id][0],
    detail: tuneNames[w.id][1],
    cap: 3,
    group: "主炮" as const,
    main: w.id,
  })),
  ...MAIN_WEAPONS.map((w) => ({
    id: `evolve-${w.id}` as UpgradeId,
    name: EVOLUTIONS[w.id].name,
    detail: EVOLUTIONS[w.id].detail,
    cap: 1,
    group: "进化" as const,
    main: w.id,
    requires: EVOLUTIONS[w.id].requires,
  })),
];
export const upgradeInfo = (id: UpgradeId) =>
  UPGRADES.find((u) => u.id === id) ?? {
    id,
    name: "旧版轻盈机翼",
    detail: "旧战局移动强化",
    cap: 8,
    group: "通用" as const,
  };
export const evolutionReady = (p: Pilot) =>
  EVOLUTIONS[p.main].requires.every((id) => (p.levels[id] ?? 0) >= 2);
export function upgradeDescription(p: Pilot, id: UpgradeId) {
  const item = upgradeInfo(id);
  if(id==='pierce'&&['laser','rail'].includes(p.main))return `贯穿光束伤害 +18% · ${p.levels[id]??0} → ${(p.levels[id]??0)+1}级`;
  return item.group === "进化"
    ? "进化 · " + item.detail
    : `${item.detail} · ${p.levels[id] ?? 0} → ${(p.levels[id] ?? 0) + 1}级`;
}
export const ENEMIES = [
  "直冲纸燕",
  "蛇形彩带",
  "横移扫射",
  "瞄准铅笔",
  "环形花火",
  "护盾纸甲",
  "分裂纸团",
  "召唤画匣",
  "冲锋剪刀",
  "狙击钢笔",
  "布雷墨瓶",
  "回旋飞镖",
  "激光尺规",
  "弹跳橡皮",
  "护航纸鸢",
  "补给运输机",
  "转向炮台",
  "巡逻坦克",
  "火箭阵地",
  "装甲列车",
];
export const BOSSES = [
  "纸翼轰炸机",
  "墨水章鱼",
  "折纸堡垒",
  "钟表裁纸机",
  "风暴水母",
  "蒸汽画鲸",
];
export const CHAPTERS = [
  {
    name: "晨光云海",
    sky: "#DDEEEB",
    ground: "#FFF4DB",
    ink: "#79ADAC",
    pool: [0, 1, 2, 3, 14, 16, 17],
    detail: "编队穿云 · 点射与扇面",
  },
  {
    name: "彩绘都市",
    sky: "#E5E9ED",
    ground: "#F4DCCA",
    ink: "#B3868D",
    pool: [0, 2, 5, 8, 9, 15, 17, 18],
    detail: "街区突袭 · 冲锋与狙击",
  },
  {
    name: "星河画卷",
    sky: "#263451",
    ground: "#484668",
    ink: "#90B9CE",
    pool: [1, 4, 6, 10, 11, 14, 16, 18],
    detail: "星尘旋涡 · 环弹与地雷",
  },
  {
    name: "翡翠雨林",
    sky: "#D3E8DA",
    ground: "#EFF1C9",
    ink: "#588B78",
    pool: [1, 6, 7, 8, 11, 15, 17, 19],
    detail: "林间伏击 · 召唤与回旋",
  },
  {
    name: "琥珀沙丘",
    sky: "#F2DBBC",
    ground: "#F6EACD",
    ink: "#B79B73",
    pool: [0, 3, 5, 9, 12, 13, 16, 19],
    detail: "遗迹长廊 · 激光与弹跳",
  },
  {
    name: "冰晶极光",
    sky: "#233D59",
    ground: "#668798",
    ink: "#ACE0DC",
    pool: [2, 4, 10, 12, 13, 14, 18, 19],
    detail: "极地合奏 · 多阶段攻击",
  },
];
export const SCENES = CHAPTERS.map((c) => c.name);
export const EVENT_NAMES = {
  formation: "编队突破",
  elite: "精英悬赏",
  convoy: "补给追击",
  recovery: "整备航段",
};
export function xpRequired(level: number) {
  return 60 + level * 22 + Math.floor(level * level * 0.65);
}
